import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import a from "./index289.js";
const l = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(s, t, p, L, i, m) {
  return e(), o("svg", n, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M9 2.25a.75.75 0 0 1 .102 1.493L9 3.75H5a1.25 1.25 0 0 0-1.244 1.122L3.75 5v14c0 .648.491 1.18 1.122 1.244L5 20.25h14a1.25 1.25 0 0 0 1.244-1.122L20.25 19v-4a.75.75 0 0 1 1.493-.102l.007.102v4a2.75 2.75 0 0 1-2.582 2.745L19 21.75H5a2.75 2.75 0 0 1-2.745-2.582L2.25 19V5a2.75 2.75 0 0 1 2.582-2.745L5 2.25h4Zm11.968 0 .103.002.089.015.04.01.092.032.114.06c.15.096.269.244.318.432l.02.097.006.102v7c0 .958-1.378.998-1.492.12L20.25 10V4.81l-7.72 7.72a.75.75 0 0 1-.976.073l-.084-.073a.75.75 0 0 1-.073-.976l.073-.084 7.719-7.72H14a.75.75 0 0 1-.743-.648L13.25 3a.75.75 0 0 1 .648-.743L14 2.25h6.968Z"
    }, null, -1)
  ]));
}
const d = /* @__PURE__ */ a(l, [["render", c]]);
export {
  d as default
};
